import React from "react"

export type TagProps = {
  children: React.ReactNode
  rounded?: boolean
  outline?: boolean
  color?: string
}

export const Tag: React.FC<TagProps> = (props) => {
  const { children } = props;

  return <div className="inline-block w-max bg-blue-500 px-2 text-xs rounded-full">{children}</div>
}
